var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditpencil(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14.648 14.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pencil-square",
    transform: "translate(-1 -0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M15.5,1.94a.5.5,0,0,1,0,.706L14.459,3.69l-2-2L13.5.646a.5.5,0,0,1,.707,0L15.5,1.939ZM13.752,4.4l-2-2L4.939,9.21a.5.5,0,0,0-.121.2l-.8,2.414a.25.25,0,0,0,.316.316l2.414-.805a.5.5,0,0,0,.2-.12L13.752,4.4Z",
    fill: "#b9b9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M1,13.5A1.5,1.5,0,0,0,2.5,15h11A1.5,1.5,0,0,0,15,13.5v-6a.5.5,0,0,0-1,0v6a.5.5,0,0,1-.5.5H2.5a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,2.5,2H9A.5.5,0,0,0,9,1H2.5A1.5,1.5,0,0,0,1,2.5Z",
    fill: "#b9b9b9",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditpencil);
export default __webpack_public_path__ + "static/media/editpencil.ae4a45d5.svg";
export { ForwardRef as ReactComponent };